import { AlertType, classBt, classInput, classInputDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { useEffect, useRef, useState } from 'react'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import * as XLSX from "xlsx"
import { FaFileDownload } from 'react-icons/fa'
import { ImLink } from 'react-icons/im'
import { ProdutoService } from '../../Pages/Products/ProdutoService'

type Props = {
    visible: boolean
    closeModalEvent: () => void
    formFields: { pl: string, bd: string }[]
    importarDados?: (planilha: any, mapa: any) => void
}

export const ModalImportacao = React.memo(({ visible, closeModalEvent, formFields, importarDados }: Props) => {

    const [columns, setColumns] = useState<string[]>([])
    const [mapping, setMapping] = useState<{ [key: string]: string }>({}) // Mapeamento das colunas para os campos do formulário
    const [celulaMapping, setCelulaMapping] = useState<{ [key: string]: string }>({}) // Mapeamento das colunas para os campos do formulário
    const fileInputRef = useRef<HTMLInputElement | null>(null) // Referência para o input de arquivo
    const [uploadedFile, setUploadedFile] = useState<File | null>(null); // Armazena o arquivo original


    //const [visibleMsg, setVisibleMsg] = useState(false)
    //const [message, setMessage] = useState("")
    //const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_abrir_importacao')
            let modalContent = document.getElementById('modal_content_abrir_importacao')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-36')
                }
            }

        } else {

            let modal = document.getElementById('modal_abrir_importacao')
            let modalContent = document.getElementById('modal_content_abrir_importacao')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-36')
                }
            }

            handleReset()
        }

    }, [visible])

    /*
    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }
    */

    const normalizeText = (text: string) => text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

    const autoMapColumns = (columns: string[]) => {
        const newMapping: { [key: string]: string } = {}
        columns.forEach((col) => {
            const normalizedCol = normalizeText(col)
            const matchingField = formFields.find(
                (field) => normalizeText(field.pl) === normalizedCol
            )
            if (matchingField) {

                newMapping[col] = matchingField.bd // Vincula a coluna ao campo correspondente
            } else {
                newMapping[col] = "" // Deixa vazio para ignorar
            }
        })
        setMapping(newMapping)
    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (file) {

            setUploadedFile(file);

            const reader = new FileReader()
            reader.onload = (e) => {
                const binaryStr = e.target?.result as string // Garante que o resultado é uma string
                const workbook = XLSX.read(binaryStr, { type: "binary" })
                const sheetName = workbook.SheetNames[0] // Pega o nome da primeira aba
                const sheet = workbook.Sheets[sheetName] // Lê a aba
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }) // Converte para array

                if (Array.isArray(jsonData) && jsonData.length > 0) {
                    const columnNames = jsonData[0] as string[] // Declara explicitamente o tipo da primeira linha

                    // Mapeia as colunas para suas respectivas letras
                    const columnMapping: Record<string, string> = {}
                    const columnLetters = Object.keys(sheet)
                        .filter((key) => /^[A-Z]+\d+$/.test(key)) // Filtra apenas as células (ex: A1, B1, etc.)
                        .filter((key) => key.endsWith("1")) // Considera apenas a primeira linha
                        .sort() // Ordena para garantir a sequência

                    columnLetters.forEach((cell, index) => {
                        const columnName = columnNames[index]
                        if (columnName) {
                            const columnLetter = cell.replace(/\d+$/, "") // Remove o número para obter apenas a letra
                            columnMapping[columnName] = columnLetter
                        }
                    })

                    setCelulaMapping(columnMapping)

                    setColumns(columnNames) // Armazena os nomes das colunas no estado

                    autoMapColumns(columnNames)
                }
            }
            reader.readAsBinaryString(file) // Lê o arquivo como string binária
        }
    }

    const handleReset = () => {
        setColumns([]) // Limpa as colunas
        setMapping({}) // Reseta o mapeamento
        if (fileInputRef.current) {
            fileInputRef.current.value = "" // Reseta o valor do input de arquivo
        }
    }

    const handleMappingChange = (column: string, value: string) => {
        setMapping((prev) => ({
            ...prev,
            [column]: value, // Atualiza o mapeamento para a coluna selecionada
        }))
    }

    const handleImportarClick = (
        celulaMapping: { [key: string]: string },
        mapping: { [key: string]: string }
    ): void => {
        const finalArray: Array<{ celula: string; valorBd: string }> = []

        Object.keys(celulaMapping).forEach((coluna) => {
            const nomeCelula = celulaMapping[coluna] // Nome da célula
            const valorBd = mapping[coluna] // Valor do BD correspondente

            if (valorBd) {
                finalArray.push({ celula: nomeCelula, valorBd })
            }
        })

        if (importarDados) {
            importarDados(uploadedFile, finalArray)
        }

    }

    return (

        <div id="modal_abrir_importacao" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 overflow-auto`}>

            <div id="modal_content_abrir_importacao" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[40%] h-[500px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center mb-8`}>

                {/* <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} /> */}

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <FaFileDownload size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <div className='flex flex-col mt-3'>
                        <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Importar Dados</span>
                        <span className={`ml-4 text-xs text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>*Apenas arquivos nos formatos .xlsx e .xls serão aceitos.</span>
                    </div>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full overflow-auto py-2`}>

                    <div className={`m-2 flex justify-center p-1`}>
                        <input ref={fileInputRef} type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
                    </div>

                    {columns.length > 0 && (

                        <div>

                            <div className={`flex flex-row space-x-2 px-2`}>

                                <div className={`w-full`}>
                                    <span className={`w-full text-slate-700 dark:text-slate-200 font-mono`}>Colunas da Planilha</span>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`w-[10%]`} />

                                <div className={`w-full`}>
                                    <span className={`w-full text-slate-700 dark:text-slate-200 font-mono`}>Colunas do Formulario</span>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                            </div>

                            {columns.map((col, index) => (

                                <div key={index} className={`flex space-x-2 px-2 py-1`}>

                                    <div className={`${classInput} ${classInputDark} cursor-auto`}>
                                        <span className={`cursor-auto`}>{col}</span>
                                    </div>

                                    <div className={`w-[10%] flex justify-center items-center`}>
                                        <ImLink className={`${mapping[col] ? "text-green-700 dark:text-green-500" : ""}`} />
                                    </div>

                                    <select className={`${classInput} ${classInputDark} `} onChange={(e) => setMapping((prev) => ({ ...prev, [col]: e.target.value }))} value={mapping[col] || ""} >

                                        <option value="" > Ignorar esse campo </option>

                                        {formFields
                                            .filter(
                                                (field) =>
                                                    !Object.values(mapping).includes(field.bd) || // Inclui se não estiver selecionado
                                                    mapping[col] === field.bd // Inclui o valor já selecionado neste select
                                            )
                                            .map((field) => (
                                                <option key={field.bd} value={field.bd}>
                                                    {field.pl}
                                                </option>
                                            ))}
                                    </select>

                                </div>

                            ))}


                        </div>
                    )}

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={() => handleImportarClick(celulaMapping, mapping)}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        IMPORTAR
                    </button>

                </div>

            </div>

        </div>

    )
})